import { render, staticRenderFns } from "./account.vue?vue&type=template&id=38fea185&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fea185",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38fea185')) {
      api.createRecord('38fea185', component.options)
    } else {
      api.reload('38fea185', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=38fea185&scoped=true&", function () {
      api.rerender('38fea185', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work_order/config/account.vue"
export default component.exports